import { Audience } from "@intentsify/types";
import { apiService, Endpoints } from "api";

export const listAudiences = async (): Promise<Audience[]> => {
  const { data } = await apiService.get<Audience[]>(Endpoints.Audience.List);

  return data;
};
